import React from 'react';
import { Button as RadixButton, Spinner } from '@radix-ui/themes';

const Button = ({
  children,
  variant = 'primary',
  size = 'medium',
  loading = false,
  disabled = false,
  fullWidth = false,
  onClick,
  type = 'button',
  className = '',
}) => {
  const radixVariant = {
    primary: 'solid',
    secondary: 'soft',
    outline: 'outline',
    danger: 'solid',
    success: 'solid',
    ghost: 'ghost',
  }[variant] || 'solid';

  const radixColor = {
    danger: 'red',
    success: 'green',
    secondary: 'gray',
    outline: 'gray',
    ghost: 'gray',
  }[variant] || 'orange';

  const radixSize = {
    small: '1',
    medium: '2',
    large: '3',
  }[size] || '2';

  return (
    <RadixButton
      type={type}
      variant={radixVariant}
      color={radixColor}
      size={radixSize}
      disabled={disabled || loading}
      onClick={onClick}
      style={fullWidth ? { width: '100%' } : undefined}
      className={className}
    >
      {loading && <Spinner size="1" />}
      {children}
    </RadixButton>
  );
};

export default Button;
